import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, "Accrued reward: " + _toDisplayString(_ctx.reward?.accruedReward), 1),
    _createElementVNode("div", _hoisted_3, "Paid out reward: " + _toDisplayString(_ctx.reward?.paidOutReward), 1)
  ]))
}